<script setup lang="ts">
import { AxiosError } from 'axios'
import type { NovaBoxBoardListEventKpopDanceSecondProps } from '@components/NovaBoxBoardListEventKpopDanceSecond/NovaBoxBoardListEventKpopDanceSecond.type'
import { ROUTES } from '@configs'

const { t } = useI18n()
const { gtEvent } = useGoogleTag()
const { showSignInDialog } = useMembershipProcess()

const mypageStore = useMyPageStore()
const kpopFestivalStore = useKpopFestivalStore()

const props = defineProps<NovaBoxBoardListEventKpopDanceSecondProps>()
const loginCheck = computed(() => {
  return !!mypageStore.profile
})
const applyCondition = ref(true)
const eventButtonAction = () => {
  gtEvent('clickEvent', {
    eventCategory: '클릭',
    eventAction: '이벤트 상세 > 커버댄스 이벤트 2차 신청 버튼 클릭',
    eventLabel: props.nttSj,
    eventSlot: '',
    eventI18nAddr: props.nttSj,
    eventComponent: 'Button',
    nttGroupId: props.nttGroupId,
  })
  try {
    if (!loginCheck.value) {
      showSignInDialog()
      return
    }
    // 신청 페이지로 이동
    useNavigations({ url: ROUTES.APPLY_KPOP_COVER_DANCE_FORM.path })
  } catch (err) {
    if (err instanceof AxiosError) {
      useToast(t('statusMessages.postReport.errors.unknown'))
    }
  }
}

const buttonLabel = computed(() => {
  if (applyCondition.value) {
    return t('applyKpopCoverDance.eventDetail.btn.apply')
  } else {
    return t('applyKpopCoverDance.eventDetail.btn.complete')
  }
})

onMounted(async () => {
  if (mypageStore.profile) {
    await kpopFestivalStore.fetchKpopFestivalApplyStatus()
    if (
      kpopFestivalStore.kpopFestivalApplyStatus?.applicationAvailableAt === 'N'
    ) {
      applyCondition.value = false
    }
  }
})
</script>

<template>
  <div class="bottom-btn-container">
    <NovaButtonText
      :label="buttonLabel"
      :width="335"
      :size="44"
      :full-width="false"
      :theme="applyCondition ? `primary-blue-dark` : 'primary-blue-light'"
      :disabled="!applyCondition"
      @click="eventButtonAction()"
    />
  </div>
</template>

<style lang="scss" scoped>
.bottom-btn-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 60px;
}
</style>
